import TablePagination from '@mui/material/TablePagination';
import LoadingScreen from 'components/LoadingScreen';
import TableWithStickyHeader from 'components/TableWithStickyHeader';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import React, { Suspense, useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import {
  //  Input,// disabling this as search functionality is broken from OpenCVE
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  //  Button,// disabling this as search functionality is broken from OpenCVE
} from 'reactstrap';

import ProductsListing from './products';
import Subscriptions from './subscriptions';
import VendorsListing from './vendors';
import {
  productPageNumberAtom,
  //  productSearchAtom, disabling this as search functionality is broken from OpenCVE
  selectedVendorAtom,
  vendorPageNumberAtom,
  //  vendorSearchAtom, disabling this as search functionality is broken from OpenCVE
  vendorsDataAtom,
  productsDataAtom,
} from '../state';

const VendorPagination: React.FC = () => {
  const vendors = useAtomValue(vendorsDataAtom);
  const [vendorPageNumber, setVendorPageNumber] = useAtom(vendorPageNumberAtom);
  const setProductPageNumber = useSetAtom(productPageNumberAtom);
  const selectedVendor = useAtomValue(selectedVendorAtom);
  const [inputPage, setInputPage] = useState<string>('');
  const [debouncedInputPage, setDebouncedInputPage] =
    useState<string>(inputPage);

  useEffect(() => {
    setProductPageNumber(1);
  }, [selectedVendor]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedInputPage(inputPage);
    }, 500);

    return () => clearTimeout(timer);
  }, [inputPage]);

  useEffect(() => {
    const parsedPage = parseInt(debouncedInputPage, 10);
    if (
      !isNaN(parsedPage) &&
      parsedPage > 0 &&
      parsedPage <= Math.ceil(vendors.count / 10)
    ) {
      setVendorPageNumber(parsedPage);
    }
  }, [debouncedInputPage]);

  if (!vendors?.count) {
    return null;
  }

  const handlePageChange = (_event, pageNumber) => {
    setVendorPageNumber(pageNumber + 1);
  };

  const handleInputChange = (event) => {
    const pageNumber = event.target.value;
    setInputPage(pageNumber);
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        textWrap: 'nowrap',
      }}
    >
      <label htmlFor="vendorPageNumber">Jump to Page</label>
      <input
        id="vendorPageNumber"
        type="number"
        value={inputPage}
        onChange={handleInputChange}
        style={{
          width: '60px',
          padding: '5px',
          textAlign: 'left',
          marginLeft: '10px',
          border: '1px solid #ccc',
          borderRadius: '4px',
        }}
      />
      <TablePagination
        rowsPerPageOptions={[]}
        component="div"
        count={vendors.count || 0}
        rowsPerPage={10}
        page={vendorPageNumber - 1}
        onPageChange={handlePageChange}
        onRowsPerPageChange={() => {}}
        style={{ width: '100%', borderTop: '1px solid #dddddd' }}
      />
    </div>
  );
};

const ProductPagination: React.FC = () => {
  const products = useAtomValue(productsDataAtom);
  const [productPageNumber, setProductPageNumber] = useAtom(
    productPageNumberAtom,
  );
  const [inputPage, setInputPage] = useState<string>('');

  if (!products?.count) {
    return null;
  }

  const handlePageChange = (_event, pageNumber) => {
    setProductPageNumber(pageNumber + 1);
  };

  const handleInputChange = (event) => {
    const pageNumber = event.target.value;
    setInputPage(pageNumber);

    const parsedPage = parseInt(pageNumber, 10);
    if (
      !isNaN(parsedPage) &&
      parsedPage > 0 &&
      parsedPage <= Math.ceil(products.count / 10)
    ) {
      setProductPageNumber(parsedPage);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        textWrap: 'nowrap',
      }}
    >
      <label htmlFor="productPageNumber">Jump to Page</label>
      <input
        id="productPageNumber"
        type="number"
        value={inputPage}
        onChange={handleInputChange}
        style={{
          width: '60px',
          padding: '5px',
          textAlign: 'left',
          marginLeft: '10px',
          border: '1px solid #ccc',
          borderRadius: '4px',
        }}
      />
      <TablePagination
        rowsPerPageOptions={[]}
        component="div"
        count={products.count || 0}
        rowsPerPage={10}
        page={productPageNumber - 1}
        onPageChange={handlePageChange}
        onRowsPerPageChange={() => {}}
        style={{ width: '100%', borderTop: '1px solid #dddddd' }}
      />
    </div>
  );
};

const CVESubscription: React.FC = () => {
  //  const setVendorPageNumber = useSetAtom(vendorPageNumberAtom); commenting this as search functionality is broken for OpenCVE
  //  const setProductPageNumber = useSetAtom(productPageNumberAtom);  commenting this as search functionality is broken for OpenCVE
  // state used for actual search keyword
  //  const setVendorSearch = useSetAtom(vendorSearchAtom); commenting this as search functionality is broken for OpenCVE
  //  bound to field value, only for display purposes
  //  const [vendorSearchFieldValue, setVendorSearchFieldValue] = useState(''); commenting this as search functionality is broken for OpenCVE

  // state used for actual search keyword
  //  const setProductsSearch = useSetAtom(productSearchAtom); commenting this as search functionality is broken for OpenCVE
  //  bound to field value, only for display purposes
  //  const [productsSearchFieldValue, setProductsSearchFieldValue] = useState(''); commenting this as search functionality is broken for OpenCVE

  const selectedVendor = useAtomValue(selectedVendorAtom);

  // eslint-disable-next-line no-warning-comments
  // TODO: reset selected vendor on vendor page change and search
  /*  commenting this as search functionality is broken for OpenCVE
    const handleVendorSearch = (event) => {
    if (event.key === 'Enter') {
      // Update state here
      searchVendor();
    }
  };

  const handleProductSearch = (event) => {
    if (event.key === 'Enter') {
      // Update state here
      searchVendor();
    }
  };

  const searchVendor = () => {
    setVendorSearch(vendorSearchFieldValue);
    setVendorPageNumber(1);
  };

  const searchProduct = () => {
    setProductsSearch(productsSearchFieldValue);
    setProductPageNumber(1);
  };
 */
  const disableCVESubscriptions = false;

  if (disableCVESubscriptions) {
    return (
      <div className="content">
        <div className="container-fluid p-0">
          <Card>
            <CardHeader>
              <CardTitle tag="h4">CVE Subscriptions</CardTitle>
            </CardHeader>
            <CardBody>
              <p>
                Security Program 360’s CVE subscription and alerting
                functionality is temporarily disabled. This is the result of the
                OpenCVE organization removing support for version 1 (v1) which
                we were using, and not providing documentation for version 2
                (v2) which is in beta testing. Once v2 is released and the APIs
                documented, the functionality will be reinstated.
              </p>
            </CardBody>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="content">
      <div className="container-fluid p-0">
        <Card>
          <CardHeader>
            <CardTitle tag="h4">CVE Subscriptions</CardTitle>
          </CardHeader>
          <CardBody>
            <Suspense fallback={<LoadingScreen />}>
              <Subscriptions />
            </Suspense>
          </CardBody>
        </Card>
        <Row>
          <Col md="6" sm="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Vendors</CardTitle>
              </CardHeader>
              {/* <Row>
                      <Col>
                        <h4>Vendors</h4>
                      </Col>
                    </Row> */}
              <CardBody>
                <Row className="align-items-center">
                  <Col xs={12} md={9}>
                    {/* commenting this as search functionality is broken
                    <Input
                      type="text"
                      placeholder="Search Vendors ..."
                      value={vendorSearchFieldValue}
                      onChange={(event) =>
                        setVendorSearchFieldValue(event.target.value)
                      }
                      onKeyDown={handleVendorSearch}
                    />
                  </Col>
                  <Col xs={12} md={3} className="d-flex justify-content-start">
                    <Button color="primary" onClick={searchVendor}>
                      Search
                    </Button> */}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <TableWithStickyHeader>
                      <thead className="text-primary">
                        <tr className="thead">
                          <th>Vendor</th>
                          {/* <th>Select</th> */}
                          <th className="text-right">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <Suspense
                          fallback={
                            <tr>
                              <td colSpan={2}>
                                <LoadingScreen />
                              </td>
                            </tr>
                          }
                        >
                          <VendorsListing />
                        </Suspense>
                      </tbody>
                    </TableWithStickyHeader>
                    <Suspense
                      fallback={
                        <tr>
                          <td colSpan={3}>
                            <LoadingScreen />
                          </td>
                        </tr>
                      }
                    >
                      <VendorPagination />
                    </Suspense>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col md="6" sm="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">
                  {selectedVendor ? (
                    <>Products for {selectedVendor}</>
                  ) : (
                    <>Products</>
                  )}
                </CardTitle>
              </CardHeader>
              <CardBody>
                <Row className="align-items-center">
                  <Col xs={12} md={9}>
                    {/* commenting this as search functionality is broken
                    <Input
                      type="text"
                      placeholder="Search Products ..."
                      value={productsSearchFieldValue}
                      onChange={(event) =>
                        setProductsSearchFieldValue(event.target.value)
                      }
                      onKeyDown={handleProductSearch}
                    />
                  </Col>
                  <Col xs={12} md={3} className="d-flex justify-content-start">
                    <Button color="primary" onClick={searchProduct}>
                      Search
                    </Button> */}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <TableWithStickyHeader>
                      <thead className="text-primary">
                        <tr className="thead">
                          <th>Product</th>
                          <th>Vendor</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <Suspense
                          fallback={
                            <tr>
                              <td colSpan={3}>
                                <LoadingScreen />
                              </td>
                            </tr>
                          }
                        >
                          <ProductsListing />
                        </Suspense>
                      </tbody>
                    </TableWithStickyHeader>
                    {selectedVendor && (
                      <Suspense
                        fallback={
                          <tr>
                            <td colSpan={3}>
                              <LoadingScreen />
                            </td>
                          </tr>
                        }
                      >
                        <ProductPagination />
                      </Suspense>
                    )}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {/* </Card> */}
      </div>
      <ToastContainer />
    </div>
  );
};

export default CVESubscription;
